import React from 'react';
import styles from './Search.module.scss';
import useTransportPermitsMatch from '../../hooks/useTransportPermitsMatch';
import { useDispatch, useSelector } from 'react-redux';
import SearchField from '../../../../../components/SearchField/SearchField';
import { textSearch } from './constants';
import { getMode, searchSelector } from './utils';
import { setSearchValue } from '../../store/action';

const Search = () => {
  const dispatch = useDispatch();
  const match = useTransportPermitsMatch();
  const { page } = match?.params || {};

  const search = useSelector(searchSelector);

  const mode = getMode({
    page,
  });

  const handleChange = (e) => {
    dispatch(setSearchValue({ [mode]: e.target.value }));
    // searchChangeCb(mode, dispatch);
  };

  return (
    <SearchField
      value={search[mode]}
      onChange={handleChange}
      className={styles.root}
      placeholder={textSearch}
    />
  );
};

export default Search;
